<style src="./style.scss">
</style>

<script lang="ts">
  import Close from "@assets/icons/close.svg";

  import Icon from "svelte-icon";

  export let message;
  export let toastType = "info";
  export let size = "small";
  export let visible = false;
  export let onClose = () => null;
</script>

{#if visible}
  <div class="toast">
    <div
      class="{`toast__content ${
        size === 'small' ? 'toast-small' : 'toast-large'
      }`}">
      <div
        class="{toastType === 'info'
          ? 'toast__content__info'
          : 'toast__content__alert'}">
        {message}
        <div class="close" on:click="{onClose}">
          <Icon data="{Close}" size="14px" stroke="transparent" />
        </div>
      </div>
    </div>
  </div>
{/if}
